import React from 'react';
import { Heart, Zap, Shield, Palette } from 'lucide-react';
import { sobreNosotros } from '../data/mockData';
import { Card } from './ui/card';

const AboutUs = () => {
  const features = [
    {
      icon: <Palette size={28} />,
      title: "Diseños Únicos",
      description: "Creamos estampados personalizados que reflejan tu estilo"
    },
    {
      icon: <Zap size={28} />,
      title: "Tecnología DTF",
      description: "Impresión de última generación para colores vibrantes"
    },
    {
      icon: <Shield size={28} />,
      title: "Calidad Garantizada",
      description: "Durabilidad comprobada con garantía de 1 mes"
    },
    {
      icon: <Heart size={28} />,
      title: "Hecho con Pasión",
      description: "Cada diseño es creado con dedicación y amor"
    }
  ];

  return (
    <section id="nosotros" className="py-24 bg-cream-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-primary-pink text-sm tracking-widest uppercase mb-4 font-medium">
            Conoce D-Lyrio
          </p>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6">
            {sobreNosotros.titulo}
          </h2>
          <div className="w-24 h-1 bg-primary-pink mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Image */}
          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src="/images/about_us/about_us.png"
                alt="Workspace"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-dusty-rose rounded-lg -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <p className="text-lg text-warm-gray leading-relaxed mb-6">
              {sobreNosotros.descripcion}
            </p>
            
            <div className="space-y-4 mb-8">
              {sobreNosotros.servicios.map((servicio, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-1.5 h-1.5 bg-primary-pink rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-charcoal">{servicio}</p>
                </div>
              ))}
            </div>

            {/* DTF Advantages Card */}
            <Card className="bg-soft-gray border-none p-6 shadow-md">
              <h3 className="text-xl font-serif text-charcoal mb-4">
                ¿Por qué DTF?
              </h3>
              <div className="space-y-3">
                {sobreNosotros.ventajasDTF.map((ventaja, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-5 h-5 bg-primary-pink/20 rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                      <div className="w-2 h-2 bg-primary-pink rounded-full"></div>
                    </div>
                    <p className="text-warm-gray text-sm">{ventaja}</p>
                  </div>
                ))}
              </div>
            </Card>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="bg-white border-none p-8 text-center hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-primary-pink/10 rounded-full flex items-center justify-center mx-auto mb-4 text-primary-pink">
                {feature.icon}
              </div>
              <h3 className="text-lg font-serif text-charcoal mb-2">
                {feature.title}
              </h3>
              <p className="text-warm-gray text-sm leading-relaxed">
                {feature.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
